// @ts-nocheck
import * as React from 'react';
import { Modal } from 'reactstrap';
import CheckGroup from 'components/uielements/CheckGroup';
import { generateForm, setFormAsTouched, updateStateObject } from 'utils/form';
import { isFormCompleted, validateField, validateForm } from 'utils/validation';
import type { RequestInfoUserData } from 'commons/types';
import type { FormInputEvent } from 'utils/form/Form.types';
import RequestForm from '../RequestForm';
import SelectedProgramCard from '../SelectedProgramCard';
import RequestModalWrapper from './RequestModal.style';
import { formStructure, formValidators } from './FormStructure';
import { DISCLAIMER } from '../../constants';
import type { RequestModalProps, SelectedProgramsProps } from './RequestModal.types';

const SelectedPrograms = ({ selectedPrograms }: SelectedProgramsProps): React.ReactElement<any> => (
  <div>
    {selectedPrograms.map((sp) => (
      <SelectedProgramCard {...sp} key={sp.id} />
    ))}
  </div>
);

const RequestModal = ({
  isOpen,
  onRequestInfo,
  onToggleModal,
  selectedPrograms,
}: RequestModalProps) => {
  const [form, setForm] = React.useState(generateForm(formStructure).form);
  const [isDisclaimerChecked, setIsDisclaimerChecked] = React.useState(true);
  const totalSelectedPrograms = selectedPrograms.length;
  const plural = totalSelectedPrograms > 1 ? 's' : '';
  const disabledClass = isDisclaimerChecked ? '' : 'disabled';
  const modalConfig = {
    contentClassName: 'request-modal-modal',
    centered: true,
    fade: false,
    isOpen,
  };

  const onToggleDisclaimer = () => setIsDisclaimerChecked(!isDisclaimerChecked);

  const onHandleInputChange = ({ currentTarget: { name, value } }: FormInputEvent): void => {
    const error = validateField(name, value, formValidators[name]);
    setForm(updateStateObject(name, value, form, error).form);
  };

  const handleOnRequestInfo = () => {
    const { isTouched, ...rest } = form;
    const userInfo: RequestInfoUserData = rest as any;
    const newErrors = validateForm(form, formValidators);

    if (isFormCompleted(newErrors, isTouched) && isDisclaimerChecked) {
      const utmValues = {
        utmSource: 'noodle_leadform_prospect',
        utmMedium: 'affiliate_cpl',
        utmContent: '/partner-programs',
        utmTerm: 'embed',
        utmCampaign: totalSelectedPrograms <= 1 ? 'exclusive' : 'shared',
      };
      onRequestInfo(selectedPrograms, { ...userInfo, ...utmValues });
    } else {
      setForm(setFormAsTouched(form, newErrors).form);
    }
  };

  const disclaimerCheckboxProps = {
    handleChange: onToggleDisclaimer,
    options: [
      {
        key: 'disclaimer-checkbox',
        label: DISCLAIMER,
        value: isDisclaimerChecked,
      },
    ],
  };
  return (
    <Modal {...modalConfig}>
      <RequestModalWrapper>
        <i
          className='icon-close_clear request-modal__close-icon'
          onClick={onToggleModal}
          onKeyPress={onToggleModal}
          role='button'
          tabIndex='0'
        />
        <h2 className='request-modal__header'>Request Information From Our Partner Programs</h2>
        <p className='request-modal__body'>
          Fill out the form below and a representative from each of the following schools will reach
          out to you directly.
        </p>
        <p className='request-modal__text'>
          {totalSelectedPrograms} Selected Program{plural}
        </p>
        <SelectedPrograms selectedPrograms={selectedPrograms} />
        <p className='request-modal__text'>Your Information</p>
        <RequestForm form={form} onInputChange={onHandleInputChange} />
        <CheckGroup {...disclaimerCheckboxProps} />
        <span
          className={`request-modal__submit ${disabledClass}`}
          onClick={handleOnRequestInfo}
          onKeyPress={handleOnRequestInfo}
          role='button'
          tabIndex={-1}
        >
          Request info
        </span>
      </RequestModalWrapper>
    </Modal>
  );
};

export default RequestModal;
